var map = {
	"./cpb-globe.svg": 2491,
	"./icon--burger.svg": 5004,
	"./icon--close.svg": 9621,
	"./icon--email.svg": 505,
	"./icon--linkedin.svg": 8041,
	"./logo--ogilvy.svg": 7707,
	"./logo--wpp.svg": 5808,
	"./logo--wpp3.svg": 4195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3394;